import React, { useState, useEffect } from "react";
import { io } from "socket.io-client";
import "./Message.css";
import messageuser2 from "../../Assets/Img/message2.png";
import messagesend from "../../Assets/Img/messagesend.png";
import nouser from "../../Assets/Img/rafiki.svg";
import axiosMain from "../../http/axiosMain";
import { Mic, Paperclip, Smile } from "lucide-react";
// import { REACT_APP_BACKEND_URL } from "../../../../.env";

// const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:5000";
const API_BASE_URL = `api/chat`;
// const userData = JSON.parse(localStorage.getItem("user") || "{}");

// try {
//   userData = userRaw ? JSON.parse(userRaw) : {};
// } catch (error) {
//   console.error("Error parsing user data from localStorage:", error);
// }

const socket = io(
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_BACKEND_URL
    : "http://localhost:5000",
  {
    autoConnect: false, // Keep manual connection
    reconnection: true, // Enable automatic reconnection
    reconnectionAttempts: 5, // Try 5 times before giving up
    reconnectionDelay: 2000,
  }
);
// // Prevent auto-connect

export default function ChatInterface() {
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [userInfo, setUserInfo] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [conversationId, setConversationId] = useState(null);

  const scrollToBottom = () => {
    const chatContainer = document.querySelector(".chat-messages");
    if (chatContainer) {
      chatContainer.scrollTop = chatContainer.scrollHeight;
    }
  };
  const fetchUserInfo = async () => {
    try {
      const response = await axiosMain.get(
        `${API_BASE_URL}/conversation/${
          JSON.parse(localStorage.getItem("user"))?.user?.user_id
        }`
      );
      const data = response.data;

      const users = data.map((item) => ({
        id: item.user.receiverId,
        email: item.user.email,
        fullName: item.user.fullName || "Unknown User",
        profilePhoto: item.user.user_profile || messageuser2,
        conversationId: item.conversationId,
        last_msg: item.last_msg,
        last_message_sent_at: item.last_message_sent_at,
      }));

      // Sort users by last message timestamp (latest first)
      users.sort(
        (a, b) =>
          new Date(b.last_message_sent_at) - new Date(a.last_message_sent_at)
      );

      setUserInfo(users);

      // Auto-select the most recent conversation
      if (users.length > 0) {
        setSelectedUser(users[0]);
        setConversationId(users[0].conversationId);

        // Scroll to bottom after setting state
        setTimeout(() => {
          scrollToBottom();
        }, 100);
      }
    } catch (error) {
      console.error("Error fetching user info:", error);
    }
  };

  useEffect(() => {
    fetchUserInfo();
  }, []);
  const handleNewMessage = (message) => {
    console.log("New Message Received:", message); // Debugging line
    setMessages((prevMessages) => [...prevMessages, message]);

    setTimeout(() => {
      scrollToBottom();
    }, 100);
  };

  useEffect(() => {
    if (conversationId) {
      fetchMessages(conversationId);
      socket.connect();
      socket.emit(
        "addUser",
        JSON.parse(localStorage.getItem("user"))?.user?.user_id
      );
      socket.emit("updateConversations", conversationId);

      socket.on("getMessage", handleNewMessage); // Adjust to correct event

      return () => {
        socket.off("getMessage", handleNewMessage);
        socket.disconnect();
      };
    }
  }, [conversationId]);
  // // Fetch Users and Their Conversations
  // const fetchUserInfo = async () => {
  //   try {
  //     const response = await fetch(`${API_BASE_URL}/conversation/${JSON.parse(localStorage.getItem("user"))?.user?.user_id}`);
  //     const text = await response.text(); // Get raw response
  //     console.log("Raw API response:", text);

  //     const data = JSON.parse(text);

  //     const users = data.map((item) => ({
  //       id: item.user.id,
  //       email: item.user.email,
  //       fullName: item.user.fullName || "Unknown User",
  //       profilePhoto: item.user.user_profile || messageuser2,
  //       conversationId: item.conversationId,
  //       last_msg: item.last_msg,
  //       last_message_sent_at: item.last_message_sent_at,
  //     }));

  //     // Sort users by last message timestamp (latest first)
  //     users.sort((a, b) => new Date(b.last_message_sent_at) - new Date(a.last_message_sent_at));

  //     setUserInfo(users);

  //     // Auto-select the most recent conversation
  //     if (users.length > 0) {
  //       setSelectedUser(users[0]);
  //       setConversationId(users[0].conversationId);
  //       // Wait for state update and scroll to bottom
  //     setTimeout(() => {
  //       scrollToBottom();
  //     }, 100);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching user info:", error);
  //   }
  // };

  // useEffect(() => {
  //   if (conversationId) {
  //     fetchMessages(conversationId);
  //   }
  // }, [conversationId]);

  // Fetch Messages for Selected Conversation
  // const fetchMessages = async (convId) => {
  //   try {
  //     if (!convId) return;
  //     const response = await fetch(`${API_BASE_URL}/message/${convId}`);
  //     const data = await response.json();

  //     setMessages(data);
  //   } catch (error) {
  //     console.error("Error fetching messages:", error);
  //   }
  // };
  const fetchMessages = async (convId) => {
    try {
      if (!convId) return;

      const response = await axiosMain.get(`${API_BASE_URL}/message/${convId}`);

      setMessages(response.data);
    } catch (error) {
      console.error(
        "Error fetching messages:",
        error.response?.data?.error || error.message
      );
    }
  };
  const [HideSIdebar, setHideSIdebar] = useState(false);
  // Handle User Selection
  const handleUserClick = (user) => {
    setSelectedUser(user);
    setConversationId(user.conversationId);
    // Wait for state update and scroll to bottom
    setHideSIdebar(true);
    setTimeout(() => {
      scrollToBottom();
    }, 100);
  };

  // Send Message
  // const handleSendMessage = async () => {
  //   if (newMessage.trim() === "" || !selectedUser || !conversationId) return;

  //   const messageData = {
  //     conversationId,
  //     senderId: JSON.parse(localStorage.getItem("user"))?.user?.user_id,
  //     receiverId: selectedUser.id,
  //     message: newMessage,
  //   };

  //   try {
  //     const response = await fetch(`${API_BASE_URL}/message`, {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify(messageData),
  //     });

  //     if (!response.ok) throw new Error("Failed to send message");

  //     setNewMessage(""); // Clear input
  //     // fetchMessages(messageData.conversationId);
  //     // Wait for state update and scroll to bottom
  //     setTimeout(() => {
  //       scrollToBottom();
  //     }, 100);
  //   } catch (error) {
  //     console.error("Error sending message:", error);
  //   }
  // };
  const handleSendMessage = async () => {
    if (newMessage.trim() === "" || !selectedUser || !conversationId) return;

    const messageData = {
      conversationId,
      senderId: JSON.parse(localStorage.getItem("user"))?.user?.user_id,
      receiverId: selectedUser.id,
      message: newMessage,
    };

    try {
      await axiosMain.post(`${API_BASE_URL}/message`, messageData);

      setNewMessage(""); // Clear input
      // fetchMessages(messageData.conversationId);
      socket.emit("sendMessage", messageData);

      // Wait for state update and scroll to bottom
      setTimeout(() => {
        scrollToBottom();
      }, 100);
    } catch (error) {
      console.error(
        "Error sending message:",
        error.response?.data?.error || error.message
      );
    }
  };

  // time in all get message
  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    const options = {
      weekday: "short",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    };
    return date.toLocaleString("en-US", options);
  };

  const [visibleTimestamp, setVisibleTimestamp] = useState(null);

  const toggleTimestamp = (index) => {
    setVisibleTimestamp(visibleTimestamp === index ? null : index);
  };

  const [searchTerm, setSearchTerm] = useState("");

  // Filter users based on search term
  const filteredUsers = userInfo.filter(
    (user) =>
      user.fullName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.last_msg?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Function to highlight matched text
  const highlightMatch = (text, term) => {
    if (!term) return text;
    const regex = new RegExp(`(${term})`, "gi");
    return text.split(regex).map((part, index) =>
      part.toLowerCase() === term.toLowerCase() ? (
        <span key={index} style={{ backgroundColor: "yellow" }}>
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  return (
    <div className="chat-container">
      {userInfo.length === 0 ? (
        <div
          className="text-center px-4 max-w-md mx-auto"
          style={{ marginTop: "8%" }}
        >
          <div
            style={{
              maxWidth: "100%", // Ensures responsiveness
              width: "auto", // Matches the design
              height: "auto", // Maintains aspect ratio
            }}
          >
            <img src={nouser} alt="No user" className="object-contain" />
          </div>
          <h2 className="Title">Welcome to the chat!</h2>
          <p
            className="text-gray-600 mb-8"
            style={{ fontSize: "24px", color: "#676767" }}
          >
            It looks like there are no messages yet.{" "}
          </p>
          <p
            className="text-gray-600 mb-8"
            style={{ fontSize: "24px", color: "#676767" }}
          >
            Start a conversation now and connect with others!
          </p>
        </div>
      ) : (
        <>
          {/* Sidebar for Users */}
          <div className="sidebar">
            <div className="sidebar-search">
              <div className="searchIcon-searchInput">
                <i
                  className="fas fa-search"
                  style={{
                    marginTop: "1%",
                    color: "#3C3C4399",
                    fontSize: "18px",
                  }}
                ></i>
                <input
                  type="text"
                  placeholder="Search for Brands"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>

            {/* {HideSIdebar ? (
              ""
            ) : ( */}
            <div className="sidebar-users">
              {filteredUsers.length > 0 ? (
                filteredUsers.map((user) => (
                  <div
                    key={user.id}
                    className={`sidebar-user-item ${
                      selectedUser?.id === user.id ? "selected" : ""
                    }`}
                    onClick={() => handleUserClick(user)}
                    style={{
                      cursor: "pointer",
                      padding: "10px",
                      borderBottom: "1px solid #ddd",
                    }}
                  >
                    <div className="sidebar-user-avatar">
                      <img src={user?.profilePhoto} alt="User" />
                    </div>

                    <div className="sidebar-user-info">
                      <div>
                        <h3>{highlightMatch(user.fullName, searchTerm)}</h3>
                        <p className="sidebar-user-lastmsg">
                          {highlightMatch(
                            user.last_msg?.length > 30
                              ? user.last_msg.substring(0, 30) + "..."
                              : user.last_msg,
                            searchTerm
                          )}
                        </p>
                      </div>
                      <div className="sidebar-user-time">
                        {new Date(user.last_message_sent_at).toLocaleDateString(
                          "en-GB",
                          {
                            day: "2-digit",
                            month: "short",
                          }
                        )}
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p>Loading user info...</p>
              )}
            </div>
            {/* )} */}
          </div>

          {/* Chat Area */}
          <div className="main-chat-area">
            <div className="chat-header">
              <div className="chat-header-avatar">
                <img
                  src={selectedUser?.profilePhoto || messageuser2}
                  alt="User Profile"
                />
              </div>
              <div className="chat-header-info">
                {selectedUser ? (
                  <>
                    <h2>{selectedUser.fullName}</h2>
                    <p>{selectedUser.email}</p>
                  </>
                ) : (
                  <h2>Select a user to chat</h2>
                )}
              </div>
            </div>

            {/* Messages Display */}
            <div className="chat-messages">
              {messages.map((message, index) => (
                <div key={index} onClick={() => toggleTimestamp(index)}>
                  <div className="chat-all-messages">
                    {message.user.id !==
                      parseInt(
                        JSON.parse(localStorage.getItem("user"))?.user?.user_id
                      ) && (
                      <img
                        src={selectedUser?.profilePhoto}
                        alt="User"
                        className="chat-message-avatar"
                      />
                    )}
                    <div
                      className={`chat-message ${
                        message.user.id ===
                        parseInt(
                          JSON.parse(localStorage.getItem("user"))?.user
                            ?.user_id
                        )
                          ? "chat-message-user"
                          : "chat-message-other"
                      }`}
                    >
                      <p>{message.message}</p>
                    </div>
                  </div>

                  {/* <div> */}
                  {visibleTimestamp === index && (
                    <span
                      className={`chat-message ${
                        message.user.id ===
                        parseInt(
                          JSON.parse(localStorage.getItem("user"))?.user
                            ?.user_id
                        )
                          ? "chat-message-timestamp-user"
                          : "chat-message-timestamp-other"
                      }`}
                    >
                      {formatTimestamp(message.user.sent_at)}
                    </span>
                  )}
                  {/* </div> */}
                </div>
              ))}
            </div>

            {/* Message Input */}
            {selectedUser && (
              <div className="chat-footer">
                <div className="input-container">
                  <Smile size={28} color="#78787C" />
                  <input
                    type="text"
                    placeholder="Start a new message"
                    value={newMessage}
                    onChange={(e) => setNewMessage(e.target.value)}
                    onKeyDown={(e) => e.key === "Enter" && handleSendMessage()}
                    // style={{ padding: "10px", width: "80%" }}
                  />
                  <Paperclip size={28} color="#78787C" />

                  {/* <img
                    src={messagesend}
                    alt="Send"
                    className="send-icon"
                    onClick={handleSendMessage}
                    style={{ cursor: "pointer", width: "25px", height: "25px" }}
                  /> */}
                </div>
                <div className="mic">
                  <Mic size={32} />
                </div>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}
